import { Configuration } from "src/app/constants/configuration";
import { Contratante } from "src/app/models/contratante.model";
import { QuattroB2C } from "src/app/models/quattroB2C.model";
import { RequestServices } from "src/app/services/request.service";
import { StorageService } from "src/app/services/storage.service";

export class AvatarHelper {
    constructor(private requestService: RequestServices, private storageService: StorageService, private quattroB2C: QuattroB2C, private contratante: Contratante) {}
    
    getAvatar() {
        try {
          this.requestService.getRequest({ projectName: new Configuration().API_B2C, apiName: 'b2c/avatar', params: [{ "clienteIDEnc": this.contratante?.clienteIDEnc }] }).subscribe(
            result => {
              if (result.error) {
                console.error(result.error)
              } else {
                this.quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C"));
                this.contratante.avatar = result.result.webPath;
                this.quattroB2C.contratante = this.contratante;
                this.storageService.setItem('quattroB2C', JSON.stringify(this.quattroB2C));
              }
            }, error => {
              console.error(error.message);
            }
          );
    
        } catch (error) {
    
          console.error("error", error);
        }
    }
}